import { ContainedTabsProps } from "components/Tabs/Tabs3";
import { CardProps, Subscription } from "./Card";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiGetSubscriptions, apiGetSubscriptionsList, apiSetSubscriptions } from "api/subsciptionApi";
import pb from "assets/icons/Plans/PlanBaseIcon.svg";
import pi from "assets/icons/Plans/PlanInfiniteIcon.svg";
import pt from "assets/icons/Plans/Trial.svg";
import ppg from "assets/icons/Plans/PlanProGoldIcon.svg";
import pp from "assets/icons/Plans/PlanProIcon.svg";
import ps from "assets/icons/Plans/PlanStandardIcon.svg";
import Text from "components/Table2/CellComps/Text";
import { apiSetAlert } from "api/appApi";
import Status from "components/Table2/CellComps/Status";
import Price from "../../../components/Table2/CellComps/Price";
import { TabsProps } from "components/Tabs";
import { apiGetBusiness } from "api/businessApi";
import { initialShopState } from "./chortkeShop/data";
import { useAppDispatch, useAppSelector } from "store/store";
import { DateToString } from "components/Reports/DateFilter";
import { apiGetDashboard } from "../../../api/dashboardApi";
import axios from "../../../axios/axios";

/* ---------------------------------- Inits --------------------------------- */
const initialCoupon = {
  show: false,
  loading: false,
  amount: 0,
  code: "",
  currency: "تومان",
  label: "",
  error: "",
};

export function days(date_1: Date, date_2: Date) {
  let difference = date_1.getTime() - date_2.getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
  return Math.abs(TotalDays);
}

export default function useSubscription() {
  /* ---------------------------------- Hooks --------------------------------- */
  const dispatch = useAppDispatch();
  const store = useAppSelector((state) => state);
  const user = store.userReducer.user;
  const token = user?.token;
  const dashboard = store.dashboardReducer.dashboard;
  const business = store.businessReducer.business?.business;
  const businessToken = store.businessReducer.business?.token;
  const promotionCode = business?.promotionCode;
  const trialExpirationDate = business?.trialExpirationDate;
  const businessId = business?.id;

  const [active, setActive] = useState<{
    subscription: null | Subscription,
    tabs1: number,
    tabs2: number,
    topTabs: number
  }>({
    subscription: null,
    tabs1: 0,
    tabs2: 0,
    topTabs: 0,
  });

  const [state, setState] = useState({
    coupon: initialCoupon,
    extraDocs: 0,
    offline: false,
    offlinePrice: 4500000,
    branchPrice: 1500000,
    shopTheme: undefined,
    shopPrice: 0,
  });
  const [history, setHistory] = useState([]);
  const [shopSate, setShopState] = useState(initialShopState);
  const [diff, setDiff] = useState(0)
  const [subs, setSubs] = useState<{ online: any[]; offline: any[] }>({ online: [], offline: [] });
  /* --------------------------------- Effects -------------------------------- */
  useEffect(() => {
    // dispatch(apiGetDashboard(business.id, token));
    // if (!businessToken) {
    //   dispatch(apiGetBusiness(business, token));
    // }
    dispatch(
      apiGetSubscriptions(token, false, (res: any, diffDate: number) => {
        setDiff(diffDate)
        setSubs((x: any) => ({ ...x, online: res.map((y: any) => ({ ...y, offline: false })) }))
      }
        , business.id)
    );
    // dispatch(
    //   apiGetSubscriptions(token, true, (res: any) =>
    //     setSubs((x: any) => ({ ...x, offline: res.map((y: any) => ({ ...y, offline: true })) }))
    //   )
    // );
    dispatch(
      apiGetSubscriptionsList(businessId, token, (history: any) => {
        setHistory(history);
      })
    );
  }, []);

  /* -------------------------------- Functions ------------------------------- */
  async function handleSubmit() {
    axios
      .post("/subscriptions/createpayment", {
        subscriptionId: active.subscription?.subId,
        businessId: business.id,
        paymentGateWay: "yektaPay",
        offlineCount: active.subscription?.offlineCount,
        branchCount: active.subscription?.branchCount,
        price: active.subscription?.price,
      }, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const uuid = response.data.paymentResult.uuid
        const url = response.data.paymentResult.url
        localStorage.setItem('yektaPayuuid', uuid)
        const paymentGateWay = response.data.paymentResult.paymentGateWay
        window.open(url, '_blank');
      })
      .catch((error) => {
      });
    // if (businessId && active.subscription) {
    //   const req = {
    //     businessId,
    //     subscriptionId: active.subscription.subId,
    //     duration: active.subscription.duration,
    //     coupon: state.coupon.code,
    //   };

    //   dispatch(apiSetSubscriptions(req, token));
    // } else {
    //   dispatch(apiSetAlert("لطفا طرح مورد نظر خود را انتخاب نمایید", "warning"));
    // }
  }

  function checkCoupon() {
    setState((x) => ({ ...x, coupon: { ...x.coupon, error: "", loading: true } }));
    const coupon = state.coupon;
    const codes = {
      fb32s: { discount: 5, condition: true },
      fb32p: { discount: 10, condition: true },
      fb32f: { discount: 15, condition: true },
      [promotionCode]: {
        discount: 20,
        condition: DateToString(new Date(trialExpirationDate)) === DateToString(new Date(Date.now())),
      },
    };

    if (Object.keys(codes).includes(coupon.code.toLowerCase())) {
      const code = codes[coupon.code.toLowerCase() as any];
      if (code && code.condition) {
        const amount = (active.subscription?.price ?? 0) * (code.discount / 100);
        setState((x) => ({
          ...x,
          coupon: {
            ...x.coupon,
            amount,
            label: `تخفیف خرید ${user.firstName} ${user.lastName}`,
            loading: false,
          },
        }));
      }
    } else {
      setState((x) => ({ ...x, coupon: { ...x.coupon, error: "کد تخفیف معتبر نمیباشد", loading: false } }));
    }

    // axios
    //     .post(
    //         "subscription/coupon",
    //         {coupon: state.coupon.code},
    //         {headers: {Authorization: `Bearer ${token}`}}
    //     )
    //     .then((res) => {
    //         setState((x) => ({
    //             ...x,
    //             coupon: {...x.coupon, amount: res.data.amount, label: res.data.label, loading: false},
    //         }));
    //     })
    //     .catch((err) => {
    //         setState((x) => ({...x, coupon: {...x.coupon, error: err.message, loading: false}}));
    //     });
  }

  function days(date_1: Date, date_2: Date) {
    let difference = date_1.getTime() - date_2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
    return Math.abs(TotalDays);
  }



  /* -------------------------------- Variables ------------------------------- */
  const subscriptions: CardProps["subscription"][] = [];
  // const icons: any = { 24: ppg, 28: ppg, 23: pp, 27: pp, 22: ps, 26: ps, 21: pb, 25: pb, 4: pi };
  const icons: any = { 35: ppg, 36: ppg, 33: pp, 34: pp, 31: ps, 32: ps, 29: pb, 30: pb, 4: pi };
  const types: any = {
    29: "base",
    30: "base",
    31: "standard",
    32: "standard",
    33: "prog",
    34: "prog",
    35: "prof",
    36: "prof",
    4: "infinite",
  };
  const durations: any = { 0: 0, 6: 1, 12: 2, 1: 3 };
  let i = 1;

  for (const sub of subs.online.sort((a: any, b: any) => (a.id < b.id ? -1 : 1))) {
    for (const x of sub.Subscription_Prices) {
      console.log(x.id, "x.id")
      i = i + 100;
      const arr = {
        id: sub.id + i,
        subPriceId: x.id,
        subId: sub.id,
        label: sub.title,
        type: types[sub.id],
        currency: "تومان",
        description: sub.description,
        icon: icons[sub.id],
        productLimit: sub.productLimit,
        userLimit: sub.userLimit,
        accountingLimit: sub.accountingLimit,
        details: sub.Subscription_Features.map((f: any) => f.title),
        price: x.price,
        renewPrice: x.renewPrice,
        duration: x.duration,
        durationTab: durations[x.duration],
        discount: x.discount,
        suggested: [4, 14, 18, 22, 26].includes(sub.id),
        offline: sub.offline,
      };
      subscriptions.push(arr);
    }
  }



  const trial: Partial<CardProps["subscription"]> = {
    label: business?.subscriptionTitle ? business?.subscriptionTitle : "آزمایشی",
    currency: "تومان",
    icon: pt,

    expireDays: days(new Date(), new Date(business?.trialExpirationDate)),
  };

  let current = trial;
  const mySubs = dashboard?.business?.Business_Subscription_Prices;
  if (mySubs && Array.isArray(mySubs) && mySubs.length > 0) {
    const sub = mySubs[0];
    const subObj = sub?.Subscription_Price?.Subscription;
    if (subObj) {
      current = {
        label: subObj.title,
        currency: "تومان",
        icon: icons[subObj.id],
        duration: sub?.Subscription_Price?.duration,
        durationTab: durations[sub?.Subscription_Price?.duration],
        expireDays: days(new Date(), new Date(sub?.end_date)),
      };
    }
  }

  const topTabs: TabsProps = {
    tabs: [{ label: "اشتراک جدید" }, { label: "تاریخچه تمدید اشتراک" }],
    style: { padding: 16, paddingBottom: 0 },
    onChange: (val) => val !== undefined && setActive((x) => ({ ...x, topTabs: val })),
  };

  const tabs1: ContainedTabsProps = {
    tabs: [
      { label: "خرید / تمدید اشتراک", activeColor: "#1062D0" },
      // { label: "تاریخچه تمدید", activeColor: "#1062D0" },
      // { label: "نرم افزار حسابداری چرتکه", activeColor: "#1062D0" },
      { label: "فروشگاه اینترنتی چرتکه", activeColor: "#1062D0" },
    ],
    activeTab: active.tabs1,
    onChange: (val) => val !== undefined && setActive((x) => ({ ...x, tabs1: val })),
  };

  const tabs2: ContainedTabsProps = {
    tabs: [
      // { label: "ماهیانه", activeColor: "#1062D0" },
      // { label: "6ماهه", activeColor: "#1062D0", badge: 10 },
      // { label: "یکساله", activeColor: "#1062D0", badge: 20 },
      { label: "مادام العمر", activeColor: "#1062D0" },
    ],
    onChange: (val) => {
      if (val !== undefined) {
        const suggested = subscriptions.find(
          (x) => active.subscription?.type === x.type && x.durationTab === val
        );
        if (suggested)
          setActive((x) => ({ ...x, tabs2: val, subscription: suggested }));
      }
    },
  };

  const table: TableProps = {
    headers: [
      { label: "شناسه پرداخت" },
      { label: "تاریخ" },
      { label: "مبلغ" },
      { label: "اشتراک" },
      { label: "وضعیت" },
    ],
    cols: [
      { Comp: Text, key: "id", getValue: (item) => item.Online_Payment.transactionId },
      { Comp: Text, key: "date" },
      { Comp: Price, key: "price" },
      { Comp: Text, key: "subscription", getValue: (item) => item.Subscription_Price.Subscription.title },
      {
        Comp: Status,
        key: "status",
        getValue: (item) => (item.Online_Payment.isSuccessful ? "موفق" : "ناموفق"),
        options: {
          inputProps: {
            bgColor: (item: any) => (item.Online_Payment.isSuccessful ? "#E7F5E9" : "#FFEAF0"),
            textColor: (item: any) => (item.Online_Payment.isSuccessful ? "#24AF22" : "#CB0B0B"),
          },
        },
      },
    ],
    rows: history,
    withoutMenu: true,
    headerColor: "#fff",
  };

  return {
    subscriptions,
    handleSubmit,
    checkCoupon,
    initialCoupon,
    tabs1,
    tabs2,
    state,
    setState,
    durations,
    active,
    setActive,
    subscription: active.subscription,
    business,
    diff,
    current,
    days,
    table,
    topTabs,
    token,
    shopSate,
    setShopState,
  };
}
